export default "__VITE_ASSET__CSPTPAbv__"